import { ACTION_EVENTS } from "../ui/UserAction";
import events from "../events/EventsObservable";
import { GAME_EVENTS } from "../game/gameEvents";
import { madnes_add_show_money } from "../engine/madnes/madnes_anims";
import {
	set_forcestopnow,
	set_win_anim_skip_click,
} from "../engine/madnes/madnes_variables";
import { madnes_adapter } from "../engine/madnes/madnes_variables";
import { CONFIG_PARAMS, MODES } from "../system/SystemConfig";
import CommanderBase from "./CommanderBase";
import { WALLET_EVENTS } from "../wallet/Wallet";
import { UISLIDER_EVENTS } from "../ui/mobile/sliders/AbstractUISlider";
import { STATES } from "../states/states";
import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import IInfoPages from "../engine/IInfoPages";
import IEngine from "../engine/IEngine";
import System from "../system/System";
import IGame from "../game/IGame";

@injectable()
export default class MadnesCommander extends CommanderBase {
	public infoPages: IInfoPages;
	public paragraph: IInfoPages;

	constructor(
		@inject(SERVICE_IDENTIFIER.System) system: System,
		@inject(SERVICE_IDENTIFIER.Game) game: IGame,
		@inject(SERVICE_IDENTIFIER.Engine) engine: IEngine,
		@inject(SERVICE_IDENTIFIER.InfoPages) infoPages: IInfoPages,
		@inject(SERVICE_IDENTIFIER.ParagraphPage) paragraph: IInfoPages,
		@inject(SERVICE_IDENTIFIER.History) public history: IInfoPages
	) {
		super(system, game, engine);

		this.infoPages = infoPages;
		this.paragraph = paragraph;

		this.preinfo = madnes_adapter.get_preinfo && madnes_adapter.get_preinfo();
	}

	async create() {
		events.subscribe(
			[
				GAME_EVENTS.GAME_START_ROUND,
				GAME_EVENTS.GAME_FREESPIN_END,
				GAME_EVENTS.GAME_END_ROUND_FREESPINS,
				GAME_EVENTS.GAME_END_ROUND_RECALCED,
				GAME_EVENTS.GAME_ADD_RESULT,
				GAME_EVENTS.GAME_ADD_FAIL_RESULT,
				WALLET_EVENTS.WALLET_ON_SET_BET,
				WALLET_EVENTS.WALLET_ON_SET_LINES_COUNT,
				ACTION_EVENTS.ACTION_BETMENU_OPEN,
				ACTION_EVENTS.ACTION_BETMENU_CLOSE,
				UISLIDER_EVENTS.UISLIDER_CHANGE_LINES,
			],
			madnes_adapter.notify
		);

		madnes_adapter.print_desk();
		madnes_adapter.print_reels();
		madnes_adapter.infomenu_init();

		madnes_add_show_money();

		this.infoPages.create();
	}

	closePreinfo() {
		madnes_adapter.preinfo_close && madnes_adapter.preinfo_close();
		this.states.resolve(STATES.PREINFO);
	}

	skip() {
		set_win_anim_skip_click(true);
	}

	forcestop() {
		if (
			this.config.get(CONFIG_PARAMS.FORCESTOP_ENABLED) &&
			this.config.get(CONFIG_PARAMS.MODE) !== MODES.REPLAY
		) {
			set_forcestopnow(true);
		}
	}
}
